import { render, staticRenderFns } from "./visitingTasksList.vue?vue&type=template&id=2db65158&scoped=true&"
import script from "./visitingTasksList.vue?vue&type=script&lang=js&"
export * from "./visitingTasksList.vue?vue&type=script&lang=js&"
import style0 from "./visitingTasksList.vue?vue&type=style&index=0&id=2db65158&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2db65158",
  null
  
)

component.options.__file = "visitingTasksList.vue"
export default component.exports